export default [
  {
    path: '/technical-control',
    redirect: '/technical-control/statement'
  },
  {
    path: '/technical-control/statement',
    name: 'technical-control-statement',
    meta: {
      access: 'technicalControlView'
    },
    component: () => import('@/views/TechnicalControl/Statement/Table')
  },
  {
    path: '/client-technical-control/statement',
    name: 'client-technical-control-statement',
    meta: {
      access: 'clientTechnicalControlView'
    },
    component: () => import('@/views/TechnicalControl/Statement/Client/Table')
  },
  {
    path: '/technical-control/statement/create',
    name: 'create-technical-control-statement',
    meta: {
      access: 'technicalControlStatementCreate'
    },
    component: () => import('@/views/TechnicalControl/Statement/Form')
  },
  {
    path: '/technical-control/statement/:id',
    name: 'technical-control-info',
    meta: {
      access: 'technicalControlView'
    },
    component: () => import('@/views/TechnicalControl/Statement/Info')
  },
  {
    path: '/client-technical-control/statement/:id',
    name: 'client-technical-control-statement-info',
    meta: {
      access: 'clientTechnicalControlView'
    },
    component: () => import('@/views/TechnicalControl/Statement/Client/Info')
  },
  {
    path: '/technical-control/statement/:id/inspection',
    name: 'technical-control-statement-inspection',
    meta: {
      access: 'inspectionCreate'
    },
    component: () => import('@/views/TechnicalControl/Inspection/FormInspection')
  },
  {
    path: '/technical-control/statement/:id/inspection/:inspectionID',
    name: 'technical-control-statement-inspection-info',
    meta: {
      access: 'inspectionCard'
    },
    component: () => import('@/views/TechnicalControl/Inspection/InfoInspection')
  }
]
